import { z } from "zod";

import { fetchWithError, useParsedQuery } from "@nens/react-query-utils";

import { favouriteStateSchema } from "./favourites";

/* Note that /bootstrap/ isn't technically part of /api/v4/, but that doesn't matter. */

// For now, just a selection of those fields of the bootstrap that we use
export const bootstrapSchema = z.object({
  user: z.object({
    authenticated: z.boolean(),
    username: z.string(),
    first_name: z.string(),
    id: z.number().nullable(),
  }),
  domain: z.string(),
  sso: z.object({
    login: z.string(),
    logout: z.string(),
  }),
  state: favouriteStateSchema,
  organisation_whitelist: z.array(z.string()).nullable(),
  default_organisation: z.string().nullable(),
  bbox: z.array(z.number()),
});

export type Bootstrap = z.infer<typeof bootstrapSchema>;

export function useBootstrap() {
  return useParsedQuery<Bootstrap>(
    ["lizard-api-v4", "bootstrap"],
    () => fetchWithError("/bootstrap/lizard/"),
    (json: unknown) => bootstrapSchema.parse(json)
  );
}
